import { Module } from 'vuex'
import { CardifAoState, state } from './state'
import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'
import { RootState } from '@/app/common/types/root-state.type'

export const cardifAoStore: Module<CardifAoState, RootState> = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
